import React from "react";
import * as styles from "./price.module.scss";
import { Subtitle } from "../Subtitle/Subtitle";

export const Price: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.month}>
          <Subtitle text={"Until March 28th"} className={styles.monthTitle} />
        </div>
        <div className={styles.eao}>
          <Subtitle text={"EAO members"} className={styles.eaoMember} />
          <Subtitle text={"€1,600*"} className={styles.eaoPrice} />
        </div>
        <div className={styles.non}>
          <Subtitle text={"Non-members"} className={styles.nonMember} />
          <Subtitle text={"€1,900*"} className={styles.nonPrice} />
        </div>
      </div>
      <div className={styles.container} style={{ paddingBottom: 0 }}>
        <div className={styles.month}>
          <Subtitle text={"From March 29th"} className={styles.monthTitle} />
        </div>
        <div className={styles.eao}>
          <Subtitle text={"EAO members"} className={styles.eaoMember} />
          <Subtitle text={"€1,850*"} className={styles.eaoPrice} />
        </div>
        <div className={styles.non}>
          <Subtitle text={"Non-members"} className={styles.nonMember} />
          <Subtitle text={"€2,200*"} className={styles.nonPrice} />
        </div>
      </div>
    </div>
  );
};
